// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimConditionModel {
    static getAttributeTypeMap() {
        return ClaimConditionModel.attributeTypeMap;
    }
}
ClaimConditionModel.discriminator = undefined;
ClaimConditionModel.additionalProperties = false;
ClaimConditionModel.attributeTypeMap = [
    {
        "name": "conditionTypeId",
        "baseName": "conditionTypeId",
        "type": "number"
    },
    {
        "name": "conditionType",
        "baseName": "conditionType",
        "type": "LookupModel"
    },
    {
        "name": "conditionStatusId",
        "baseName": "conditionStatusId",
        "type": "number"
    },
    {
        "name": "conditionStatus",
        "baseName": "conditionStatus",
        "type": "LookupModel"
    },
    {
        "name": "conditionStatusCategoryId",
        "baseName": "conditionStatusCategoryId",
        "type": "number"
    },
    {
        "name": "conditionStatusCategory",
        "baseName": "conditionStatusCategory",
        "type": "LookupModel"
    },
    {
        "name": "isCompleted",
        "baseName": "isCompleted",
        "type": "boolean"
    },
];
//# sourceMappingURL=claimConditionModel.js.map